import { GET_COUNTRY_ENUM_VALUES_QUERY } from './useGetCountryEnumValues.graphql';
import {
  IGetCountryEnumValuesQueryGraphQLResponse,
  IUseGetCountryEnumValues,
  IUseGetCountryEnumValuesOptions,
} from './useGetCountryEnumValues.interfaces';

import { useKanziLazyQuery } from '../../apollo';

const useGetCountryEnumValues = (options?: IUseGetCountryEnumValuesOptions): IUseGetCountryEnumValues => {
  const { fetchPolicy, onCompleted, onError, query, token } = options ?? ({} as IUseGetCountryEnumValuesOptions);

  const [executeGetCountryEnumValues, { loading: isLoading }] = useKanziLazyQuery<IGetCountryEnumValuesQueryGraphQLResponse>({
    options: {
      fetchPolicy: fetchPolicy ?? 'cache-first',
      onCompleted: (data) => {
        if (!onCompleted) {
          return;
        }

        const {
          countryEnums: { enumValues },
        } = data;

        onCompleted({
          enumValues,
        });
      },
      onError,
    },
    query: query ?? GET_COUNTRY_ENUM_VALUES_QUERY,
    token,
  });

  const handleGetCountryEnumValues = () => {
    executeGetCountryEnumValues();
  };

  return {
    handleGetCountryEnumValues,
    isLoading,
  };
};

export { useGetCountryEnumValues };
